<template>
    <div class="form-group">
        <label :for="getId" v-text="getLabel"></label>
        <textarea
                :id="getId"
                class="form-control"
                v-model="currentValue"
                ref="autoSize"
                @updated="autosize"
                @keydown="autosize"
        ></textarea>
    </div>

</template>

<script>
    import fieldInfo from './../mixins/fieldInfo';
    import autoSize from "../mixins/autoSize";

    export default {
        mixins: [
            fieldInfo,
            autoSize,
        ],
        data() {
            return {};
        },
        methods: {},
        created() {
            this.ref = Math.random().toString(36).substr(2, 9);
        },
        mounted() {}
    }
</script>
